import { OwnersAction } from "./actions";
import { IOwners, IOwnersActionTypes } from "./types";

const defaultState: IOwners = {
    data: [],
    getOwnersLoading: undefined,
};

const ownersReducer = (state = defaultState, action: OwnersAction) => {
    switch (action.type) {
        case IOwnersActionTypes.GET_OWNERS:
            return { ...state, data: action.payload };

        case IOwnersActionTypes.GET_OWNERS_LOADING:
            return { ...state, getOwnersLoading: action.payload };

        default:
            return state;
    }
};

export default ownersReducer;
